<app-wizard-modal
    [isLoading]="isLoading"
    [vertical]="true"
    (cancel)="onWizardCancel()"
    (stepChange)="onStepChange($event)"
    (submit)="onWizardSubmit()">
    <app-wizard-title>{{'admin.tools.form.title' | translate}}</app-wizard-title>

    <app-wizard-step>
        <ng-template #title>{{'admin.tools.form.sections.details' | translate}}</ng-template>
        <ng-template #content
                     let-step="step">
            <form [formGroup]="isSpareForm" class="is-spare-form">
                <app-input-switch
                    [formControl]="isSpareForm.controls['isSpare']"
                    onLabel="{{'generic.yes' | translate}}"
                    offLabel="{{'generic.no' | translate}}"
                    topLabel="{{'admin.tools.details.detailsPage.labels.isSpare' | translate}}">
                </app-input-switch>
            </form>

            <div class="info-row">
                <span>{{'admin.tools.form.labels.name' | translate}}:</span>
                <span>{{toolSet.children[0].name}}</span>
            </div>

            <div class="info-row">
                <span>{{'intervention-modal.description.label' | translate}}:</span>
                <span>{{toolSet.children[0].details.description || 'N/A'}}</span>
            </div>

            <div class="info-row">
                <span>{{'admin.tools.form.labels.owner.label' | translate}}:</span>
                <span>{{toolSet.children[0].owner.name}}</span>
            </div>

            <div class="info-row">
                <span>{{'admin.tools.form.labels.line.label' | translate}}:</span>
                <span>{{toolSet.children[0].mainLine.name}}</span>
            </div>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canSave]='canSave'>
        <ng-template #title>{{'admin.tools.form.sections.codes' | translate}}</ng-template>
        <ng-template #content
                     let-step="step">
            <div class="center">
                <form [formGroup]="detailsForm" class="is-spare-form">
                    <app-dropdown-autocomplete
                        [formControl]="detailsForm.controls.codingType"
                        [items]="codingTypeOptions"
                        [useObjects]="true"
                        displayField="label"
                        valueField="value"
                        [appendTo]="'body'"
                        [showErrors]="showValidations"
                        [label]="'admin.tools.form.labels.codingType' | translate"
                        [emptyText]="'admin.tools.form.labels.codingType' | translate">
                    </app-dropdown-autocomplete>
                    <ng-container *ngIf="!isToolCodeAutoGenerated(); else autoGeneratedToolCodeMessage">
                        <app-input [formControl]="detailsForm.controls.mesCode"
                                   [showErrors]="showValidations || detailsForm.controls.mesCode.dirty"
                                   [isReadonly]="isToolCodeReadonly()"
                                   placeholder="{{'admin.tools.form.labels.toolCode' | translate }}"
                                   label="{{'admin.tools.form.labels.toolCode' | translate }}">
                        </app-input>
                    </ng-container>
                    <ng-template #autoGeneratedToolCodeMessage>
                        <div class="tool-code-generated-message">
                            <label>{{'admin.tools.form.labels.toolCode' | translate }}</label>
                            <span>{{ 'admin.tools.form.messages.toolCodeAutoGeneratedAfterSave' | translate }}</span>
                        </div>
                    </ng-template>
                    <button
                        *ngIf="canReopenInfoModal()"
                        type="button"
                        class="info-modal-reopen"
                        (click)="reopenInfoModal()"
                        [title]="'validation.toolCode.infoModal.title' | translate">
                        <i class="material-icons">warning</i>
                    </button>
                    <app-input [formControl]="detailsForm.controls.toolControlName"
                               [showErrors]="showValidations"
                               placeholder="{{'admin.tools.form.labels.toolControlName' | translate }}"
                               label="{{'admin.tools.form.labels.toolControlName' | translate }}">
                    </app-input>
                    <app-input [formControl]="detailsForm.controls.supplierCode"
                                [showErrors]="showValidations"
                                placeholder="{{'admin.tools.form.labels.supplierCode' | translate }}"
                                label="{{'admin.tools.form.labels.supplierCode' | translate }}">
                    </app-input>
                    <app-input [formControl]="detailsForm.controls.inventoryNumber"
                                [showErrors]="showValidations"
                                placeholder="{{'admin.tools.form.labels.inventoryNumber' | translate }}"
                                label="{{'admin.tools.form.labels.inventoryNumber' | translate }}">
                    </app-input>

                </form>
            </div>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step
        [isAfterSubmit]="true">
        <ng-template #title>{{'admin.tools.form.sections.engrave' | translate}}</ng-template>
        <ng-template #content
                     let-step="step">
            <app-tool-engrave [toolsToScan]="toolDatamatrix"
                              [isScanListenerActive]="step.isActive"></app-tool-engrave>
        </ng-template>
    </app-wizard-step>
</app-wizard-modal>
<app-tool-property-validation-info-modal
    #infoModal
    [title]="'validation.toolCode.infoModal.title' | translate"
    [message]="'validation.toolCode.infoModal.message' | translate"
    [tools]="infoModalTools"
    (confirm)="onInfoConfirm()">
</app-tool-property-validation-info-modal>
